import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { track } from '@amplitude/unified'
import Footer from '../Partials/Footer'
import Header from '../Partials/Header'
import ContactUs from './ContactUs'
import TestimonialScroll from './testimonial'

export default function Home() {
    useEffect(() => {
        track('Page Viewed', { pageName: 'Home' });
    }, []);

    return (
        <div  id="home">
            <Header />

            <section className='home'>
                <div className="container">
                    <div className="home--container">
                        <div className="home__header text-center">
                            <h1>Accelerating Utility-Scale Solar <br/>Construction with Tech</h1>
                        </div>
                        <div className="header__subheading mt-3">
                            <h4 style={{textAlign:"center"}}>We specialise in solar-specific solutions that streamline construction workflows, improve project visibility, and help deliver utility-scale projects on time and under budget.</h4>
                        </div>
                        <div className="header__img mt-4">
                            <img src="/images/home1.png" alt="" />                            
                        </div>
                    </div>
                </div>
            </section>

            <section className="solar">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <div className="solar__header">
                                <h3>Accelerate and optimise solar installs with Surya</h3>
                            </div>
                            <div className="solar__product--btn mt-3">
                                <Link to={'/product'} onClick={()=>{track('CTA Clicked', { buttonName: 'View Products', section: 'Hero' });}}><button type='submit'>View products</button></Link>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6 position-relative">
                            <div className="solar__img">
                                <img src="/images/solar.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container"> <div>
                <div className="about__header">
                <h2>Client Testimonials</h2>
                </div>
                <div className="about__paragraph ml-20">
                <p style={{padding:"0%", fontweiht:"10"}}>
                    What our customers have to say about working with us
                </p>
                </div>
            </div>
            
            {/* Testimonials Container */}
            <TestimonialScroll/>
            </div>

            <ContactUs/>
            <Footer/>
        </div>
    )
}
